import { render, staticRenderFns } from "./SdTemporaryEditor.vue?vue&type=template&id=8cbd2f20&scoped=true"
import script from "./SdTemporaryEditor.vue?vue&type=script&lang=js"
export * from "./SdTemporaryEditor.vue?vue&type=script&lang=js"
import style0 from "./SdTemporaryEditor.vue?vue&type=style&index=0&id=8cbd2f20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cbd2f20",
  null
  
)

export default component.exports